import { Component, AfterViewInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { StockService } from '../../../service/stock/stock.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-root',
  templateUrl: 'wa6014.component.html',
  styleUrls: ['wa6014.component.css']
})
export class Wa6014Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA6014:在庫実績送信・荷主選択';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public updprogramCd = 'wa6014';
  private errorInfo = '';
  private gridHelper: AgGridHelper;
  private isEnableClearFilterButton = false;

  constructor(
    private router: Router,
    private stockService: StockService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa6014_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.errorInfo = '';
      },
      onRowDataChanged: () => {
        this.gridHelper.onRowDataChanged();
        this.errorInfo = '';

        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 40,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: true
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 200)
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 300)
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa6014_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa6014_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa6014_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onSubmit();
    }, 500);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onSubmit() {
    this.working = true;
    this.ownerService
      .get()
      .then(outputJson => {
        this.working = false;
        console.log(outputJson);
        this.rowData = outputJson.owners;
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  sendResult() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    const selectItems: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      const jsonUnit: object = {
        ownerId: this.rowData[rowIndex]['ownerId']
      };
      selectItems.push(jsonUnit);
    }
    console.log(selectItems);
    this.working = true;
    this.stockService
      .sendResult(selectItems, this.updprogramCd)
      .then(outputJson => {
        this.working = false;
        this.router.navigate(['wa6010']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6014/wa6014.component.ts